/**
 * Public, indexable paper catalogue.
 *
 * This is deliberately a small SEO snapshot rather than the question bank:
 * draft questions and unverified corrections must not become public URLs.
 * Each entry represents one complete paper that already exists in corpus v3.
 */
export const EXAM_PAPERS = Object.freeze([
  {
    diploma: 'bac-premiere', year: 2026, slug: 'bac1maths-2026-po3', code: 'BAC1MATHS_2026_PO3',
    label: 'Polynésie — remplacement', exerciseCount: 4,
    sourceUrl: 'https://www.sujetdebac.fr/annales-pdf/2026/mathematiques-spe-premiere-2026-polynesie-remplacement-sujet-officiel.pdf',
    topics: ['Fonctions', 'Probabilités', 'Suites', 'Dérivation', 'Second degré', 'Algorithmique'],
  },
  {
    diploma: 'bac-premiere', year: 2027, slug: 'bac1maths-sujet0-1', code: 'BAC1MATHS_SUJET0_1',
    label: 'Sujet zéro 1', exerciseCount: 3,
    sourceUrl: 'https://eduscol.education.gouv.fr/sites/default/files/document/sujet-specialite-1pdf-112050.pdf',
    topics: ['Fonctions', 'Dérivation', 'Probabilités', 'Statistiques', 'Géométrie repérée', 'Suites'],
  },
  {
    diploma: 'bac-premiere', year: 2027, slug: 'bac1maths-sujet0-2', code: 'BAC1MATHS_SUJET0_2',
    label: 'Sujet zéro 2', exerciseCount: 3,
    sourceUrl: 'https://eduscol.education.gouv.fr/sites/default/files/document/sujet-specialite-2pdf-112053.pdf',
    topics: ['Second degré', 'Dérivation', 'Probabilités', 'Suites', 'Pourcentages', 'Calcul littéral'],
  },
  {
    diploma: 'bac-terminale', year: 2024, slug: '24-matj2me2', code: '24-MATJ2ME2',
    label: 'Métropole — jour 2', exerciseCount: 4,
    sourceUrl: 'https://www.sujetdebac.fr/annales-pdf/2024/spe-mathematiques-2024-metropole-2-sujet-officiel.pdf',
    topics: ['Probabilités', 'Suites', 'Géométrie dans l’espace', 'Limites', 'Convexité', 'Équations différentielles'],
  },
  {
    diploma: 'bac-terminale', year: 2025, slug: '25-matj2me3', code: '25-MATJ2ME3',
    label: 'Métropole — remplacement', exerciseCount: 4,
    sourceUrl: 'https://www.sujetdebac.fr/annales-pdf/2025/spe-mathematiques-2025-metropole-2-remplacement-sujet-officiel.pdf',
    topics: ['Probabilités', 'Suites', 'Géométrie dans l’espace', 'Logarithme', 'Primitives', 'Algorithmique'],
  },
  {
    diploma: 'bac-terminale', year: 2026, slug: '26-matj1me1', code: '26-MATJ1ME1',
    label: 'Métropole — jour 1', exerciseCount: 4,
    sourceUrl: 'https://www.sujetdebac.fr/annales-pdf/2026/spe-mathematiques-2026-metropole-1-sujet-officiel.pdf',
    topics: ['Probabilités', 'Suites', 'Intégrales', 'Logarithme', 'Géométrie dans l’espace', 'Équations différentielles'],
  },
  {
    diploma: 'bac-terminale', year: 2026, slug: '26-matj2me1', code: '26-MATJ2ME1',
    label: 'Métropole — jour 2', exerciseCount: 4,
    sourceUrl: 'https://www.sujetdebac.fr/annales-pdf/2026/spe-mathematiques-2026-metropole-2-sujet-officiel.pdf',
    topics: ['Probabilités', 'Suites', 'Intégrales', 'Exponentielle', 'Géométrie dans l’espace', 'Équations différentielles'],
  },
  {
    diploma: 'bac-terminale', year: 2026, slug: '26-matj2me3', code: '26-MATJ2ME3',
    label: 'Métropole — remplacement', exerciseCount: 4,
    sourceUrl: 'https://www.sujetdebac.fr/annales-pdf/2026/spe-mathematiques-2026-metropole-2-remplacement-sujet-officiel.pdf',
    topics: ['Probabilités', 'Suites', 'Intégrales', 'Convexité', 'Géométrie dans l’espace', 'Algorithmique'],
  },
  {
    diploma: 'brevet', year: 2024, slug: '24genmatpo1', code: '24GENMATPO1',
    label: 'Sujet officiel 24GENMATPO1', exerciseCount: 5,
    sourceUrl: 'https://eduscol.education.gouv.fr/sites/default/files/document/24-genmatpo1-a16pdf-109815.pdf',
    topics: ['Arithmétique', 'Fonctions', 'Probabilités', 'Statistiques', 'Pythagore et Thalès', 'Algorithmique'],
  },
  {
    diploma: 'brevet', year: 2025, slug: '25genmatmeag1', code: '25GENMATMEAG1',
    label: 'Sujet officiel 25GENMATMEAG1', exerciseCount: 5,
    sourceUrl: 'https://www.education.gouv.fr/sites/default/files/2025-06/dipl-me-national-du-brevet-2025-math-matiques-441366.pdf',
    topics: ['Calcul littéral', 'Probabilités', 'Statistiques', 'Proportionnalité', 'Géométrie', 'Tableur'],
  },
  {
    diploma: 'brevet', year: 2025, slug: '25genmatg11', code: '25GENMATG11',
    label: 'Sujet officiel 25GENMATG11', exerciseCount: 5,
    sourceUrl: 'https://www.education.gouv.fr/sites/default/files/2025-06/dipl-me-national-du-brevet-2025-math-matiques-441135.pdf',
    topics: ['Arithmétique', 'Calcul littéral', 'Probabilités', 'Statistiques', 'Pythagore et Thalès', 'Algorithmique'],
  },
  {
    diploma: 'brevet', year: 2025, slug: '25genmataa1', code: '25GENMATAA1',
    label: 'Sujet officiel 25GENMATAA1', exerciseCount: 5,
    sourceUrl: 'https://www.education.gouv.fr/sites/default/files/2025-06/dipl-me-national-du-brevet-2025-math-matiques-441171.pdf',
    topics: ['Arithmétique', 'Fractions', 'Probabilités', 'Statistiques', 'Pythagore et Thalès', 'Algorithmique'],
  },
  {
    diploma: 'brevet', year: 2026, slug: '26genmatan1', code: '26GENMATAN1',
    label: 'Sujet officiel 26GENMATAN1', exerciseCount: 5,
    sourceUrl: 'https://www.education.gouv.fr/sites/default/files/document/diplome-national-du-brevet-2026-mathematiques-serie-generale-516986.pdf',
    topics: ['Arithmétique', 'Fonctions', 'Probabilités', 'Statistiques', 'Trigonométrie', 'Scratch'],
  },
  {
    diploma: 'brevet', year: 2026, slug: '26genmatag1', code: '26GENMATAG1',
    label: 'Sujet officiel 26GENMATAG1', exerciseCount: 4,
    sourceUrl: 'https://www.education.gouv.fr/sites/default/files/document/diplome-national-du-brevet-2026-mathematiques-serie-generale-518657.pdf',
    topics: ['Fonctions', 'Statistiques', 'Proportionnalité', 'Pythagore et Thalès', 'Transformations', 'Tableur'],
  },
  {
    diploma: 'brevet', year: 2026, slug: '26genmataa1', code: '26GENMATAA1',
    label: 'Sujet officiel 26GENMATAA1', exerciseCount: 5,
    sourceUrl: 'https://www.education.gouv.fr/sites/default/files/document/diplome-national-du-brevet-2026-mathematiques-serie-generale-517553.pdf',
    topics: ['Calcul littéral', 'Probabilités', 'Statistiques', 'Pythagore et Thalès', 'Algorithmique', 'Volumes'],
  },
].map(Object.freeze));

export const examPaperPath = (paper) => `/examens/${paper.diploma}/${paper.year}/${paper.slug}`;

export const findExamPaper = (diploma, year, slug) => EXAM_PAPERS.find((paper) => (
  paper.diploma === String(diploma || '').toLowerCase()
  && String(paper.year) === String(year || '')
  && paper.slug === String(slug || '').toLowerCase()
)) || null;

